import { render, staticRenderFns } from "./QRCodeAuthorization.vue?vue&type=template&id=0cc77118&scoped=true"
import script from "./QRCodeAuthorization.vue?vue&type=script&lang=js"
export * from "./QRCodeAuthorization.vue?vue&type=script&lang=js"
import style0 from "./QRCodeAuthorization.vue?vue&type=style&index=0&id=0cc77118&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc77118",
  null
  
)

export default component.exports